// Org-scoped roles: require an organizationId at invite time and get a membership row.
export const ORG_SCOPED_ROLES = ["practice_admin", "pcp", "clinical_support_staff"];
// Internal TeleCurb staff roles: no mandatory org membership.
// Only platform_admin can invite these.
export const INTERNAL_STAFF_ROLES = ["specialist", "consult_curator"];
// Org-optional roles: internal staff that may optionally be credentialed to one or more orgs.
export const ORG_OPTIONAL_ROLES = ["consult_curator"];
// platform_admin is invitable too (TEL-171) — but only by another platform_admin
// (enforced in invite.service), takes no org/specialty, and still requires
// accept-invite + MFA enrollment. The *first* platform admin is still bootstrapped
// out-of-band via seed-platform-admin; this just lets admins add peers in-app.
export const INVITABLE_ROLES = [
    ...ORG_SCOPED_ROLES,
    ...INTERNAL_STAFF_ROLES,
    "platform_admin",
];
// TEL-284: draft consult visibility is scoped by the CREATOR's role family, not
// just the org. Practice-side actors (pcp / CSS) share drafts with each other;
// curators share drafts with other curators; neither family sees the other's
// drafts. Enforced at the service layer (listDrafts / draft edit + submit) AND
// in the consults RLS policies — keep the role lists in sync with
// consults_org_select / consults_org_write / consults_curator in
// packages/db/src/schema.ts.
export const DRAFT_ROLE_FAMILIES = {
    practice: ["pcp", "clinical_support_staff"],
    curator: ["consult_curator"],
};
// The family a role belongs to for draft visibility, or null for roles with no
// draft family (platform_admin sees all drafts; practice_admin / specialist
// have no draft access at all).
export function draftFamilyForRole(role) {
    for (const family of Object.keys(DRAFT_ROLE_FAMILIES)) {
        if (DRAFT_ROLE_FAMILIES[family].includes(role))
            return family;
    }
    return null;
}
// 8-state consult lifecycle. Keep in sync with the DB-level CHECK constraint at
// packages/db/src/schema.ts (CONSULT_STATUSES). Defined here so packages that
// can't depend on @telecurb/db (e.g. @telecurb/shared) have access to the enum.
export const CONSULT_STATUSES = [
    "draft",
    "submitted",
    "assigned",
    "accepted",
    "answered",
    "follow-up-active",
    "clarification-requested",
    "closed",
    "cancelled",
];
//# sourceMappingURL=types.js.map